import httpClient from 'shared/lib/httpClient';
import { parseTariffBookList } from '../schemas/TariffBookSchema';

export const getTariffBookList = async (params, signal) => {
  const response = await httpClient.get('/tariff-books', { params, signal });
  return parseTariffBookList(response?.data);
};
